import React from "react";
import classnames from "classnames";
import LoginStore from "../stores/login-store";
import AppRoutes from '../routes/routes';
import { withRouter } from "react-router";
import MarketingNav from './navigation/marketing-nav';
import MarketingFooter from './homepage/marketing-footer';

import '../../css/design-system.scss';

class LoggedOutTemplate extends React.Component {
  constructor() {
    super();
    this.state = {
      popupActive: false
    };
    this.openModal = this.openModal.bind(this);
  }

  openModal({ location }) {
    const { query } = location;
    const expectedModals = [
      "login",
      "register",
      "forgot-password",
      "password-reset",
      "thank-you",
      "verify-token"
    ];

    if (query && query.modal && expectedModals.includes(query.modal)) {
      this.setState({
        popupActive: true
      });
      return;
    }

    this.setState({
      popupActive: false
    });
  }
  render() {
    const classes = classnames({
      "logged-in": LoginStore.isLoggedIn(),
      "main-container": true,
      clearfix: true
    });

    const { pathname } = this.props.location;
    const key = pathname || "root";
    const isChatPage = pathname.startsWith(AppRoutes.chat);

    return (
      <div className={classes}>
        {!isChatPage && <MarketingNav {...this.props} userLoggedIn={LoginStore.isLoggedIn()} />}
        <React.Fragment key={key}>
          {React.cloneElement(this.props.children || <div />, { key: key })}
        </React.Fragment>
        {!isChatPage && <MarketingFooter />}
      </div>
    );
  }
}

export default withRouter(LoggedOutTemplate);
